import { useEffect, useRef, useState } from "react";

const LazyLoadSection = ({ children, height = "300px" }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect(); // Stop observing after load
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1, // 10% visibility required
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ minHeight: height }}>
      {isVisible ? (
        children
      ) : (
        <div style={{ height }}>{/* skeleton optional */}</div>
      )}
    </div>
  );
};

export default LazyLoadSection;
